import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// --- Anti-inspect protection ---
// Disable right-click context menu
document.addEventListener('contextmenu', e => e.preventDefault());
// Block common DevTools keyboard shortcuts
document.addEventListener('keydown', e => {
  // F12
  if (e.key === 'F12') {
    e.preventDefault();
    return false;
  }
  // Ctrl+Shift+I (Inspect), Ctrl+Shift+J (Console), Ctrl+Shift+C (Element picker)
  if (e.ctrlKey && e.shiftKey && ['I', 'i', 'J', 'j', 'C', 'c'].includes(e.key)) {
    e.preventDefault();
    return false;
  }
  // Ctrl+U (View Source)
  if (e.ctrlKey && (e.key === 'u' || e.key === 'U')) {
    e.preventDefault();
    return false;
  }
  // Cmd+Option+I / Cmd+Option+J (Mac)
  if (e.metaKey && e.altKey && ['i', 'I', 'j', 'J'].includes(e.key)) {
    e.preventDefault();
    return false;
  }
});
// Disable text selection and drag
document.addEventListener('selectstart', e => e.preventDefault());
document.addEventListener('dragstart', e => e.preventDefault());
// --- Advanced DevTools Detection ---
// Technique 1: debugger timing detection
function detectDevTools() {
  const threshold = 160;
  const before = performance.now();
  // The debugger statement pauses execution ONLY when DevTools is open
  // eslint-disable-next-line no-debugger
  debugger;
  const after = performance.now();
  if (after - before > threshold) {
    onDevToolsDetected();
  }
}
// Technique 2: console object size detection
function detectViaConsole() {
  const element = new Image();
  let devtoolsOpen = false;
  Object.defineProperty(element, 'id', {
    get: function () {
      devtoolsOpen = true;
    }
  });
  console.dir(element);
  if (devtoolsOpen) {
    onDevToolsDetected();
  }
}
// Technique 3: window size detection (DevTools changes inner dimensions)
let lastWidth = window.outerWidth - window.innerWidth;
let lastHeight = window.outerHeight - window.innerHeight;
function detectViaWindowSize() {
  const widthDiff = window.outerWidth - window.innerWidth;
  const heightDiff = window.outerHeight - window.innerHeight;
  // If the difference suddenly increases by >200px, DevTools likely opened
  if (widthDiff > 200 || heightDiff > 200) {
    onDevToolsDetected();
  }
}
// What happens when DevTools is detected
function onDevToolsDetected() {
  // Blank the entire page
  document.documentElement.innerHTML = '';
  document.body.style.background = '#04080f';
  // Create warning overlay
  const overlay = document.createElement('div');
  overlay.style.cssText = `
    position:fixed;inset:0;background:#04080f;display:flex;
    align-items:center;justify-content:center;flex-direction:column;
    font-family:Inter,system-ui,sans-serif;z-index:999999;
  `;
  overlay.innerHTML = `
    <div style="color:#b8a06a;font-size:48px;margin-bottom:16px;">⚠</div>
    <h1 style="color:#f0ead8;font-size:24px;font-weight:700;margin-bottom:8px;">
      Access Denied
    </h1>
    <p style="color:#3a5070;font-size:14px;">
      Developer tools are not permitted on this page.
    </p>
  `;
  document.body.appendChild(overlay);
  // Stop all intervals
  clearInterval(checkInterval1);
  clearInterval(checkInterval2);
  clearInterval(checkInterval3);
}
// Run detection checks every 1-2 seconds
const checkInterval1 = setInterval(detectViaConsole, 1000);
const checkInterval2 = setInterval(detectViaWindowSize, 1500);
const checkInterval3 = setInterval(detectDevTools, 2000);
// Clear console continuously to make it harder to read
setInterval(() => {
  console.clear();
}, 500);
// --- Render App ---
render(<App data-id="element-140" />, document.getElementById('root'));